import React from 'react';
import auth from '@/auth/authProvider';
import IconButton from '@/components/buttons/IconButton';

const LogoutButton = () => (
  <IconButton
    className="aridhia-home-button primary"
    icon
    labelPosition="left"
    iconName="sign out"
    iconClassName="primary"
    messageId="back.to.login"
    onClick={() => auth().logout()}
  />
);

export default LogoutButton;
